import {jqBody, jqContentWrapper, jqHtml} from '../util/jq';
import mappings from '../pageMappings';

export default function changePageClass(currentPage) {
  jqContentWrapper().addClass(currentPage);
  // Handle class on html element.
  for (let page in mappings) {
    jqBody.removeClass(`${page}-body`);
    jqHtml.removeClass(`${page}-html`);
  }
  jqBody.addClass(`${currentPage}-body`);
  jqHtml.addClass(`${currentPage}-html`);
}



// WEBPACK FOOTER //
// ./src/main/js/pages/_changePageClass.js